import type { ReactNode } from 'react'

export function MobileAuthLayout({
  actions,
  children,
}: {
  actions?: ReactNode
  children: ReactNode
}) {
  return (
    <main
      className="auth-stage min-h-dvh overflow-x-clip bg-white px-6 text-[var(--color-text)]"
      data-testid="mobile-auth-layout"
    >
      {actions ? <div className="fixed right-4 top-4 z-20">{actions}</div> : null}
      <section className="relative z-10 flex min-h-dvh items-center justify-center py-8">
        <div className="w-full max-w-[360px] bg-transparent px-0 py-10">{children}</div>
      </section>
    </main>
  )
}
